import persianDate from 'persian-date';

const LocalizedDate = ({date, format}) =>
    <>
        {date ? new persianDate(date).format(format) : ''}
    </>

export default LocalizedDate